import moment from 'moment-timezone';
import { numberUnmask } from 'utils/unmask';
import { getOrConvertToPst } from 'utils/timezone';

export default {
  firstPaymentDate: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 8) {
        return 'Payment Date is not valid';
      }

      if (!moment(input, 'MM/DD/YYYY').isValid()) {
        return 'Payment Date is not valid';
      }

      const lowBound = getOrConvertToPst().add(35, 'd');
      const upBound = getOrConvertToPst().add(45, 'd');
      const inputDate = moment.tz(input, 'MM/DD/YYYY', 'America/Los_Angeles');

      if (inputDate.isBefore(lowBound, 'day') || inputDate.isAfter(upBound, 'day')) {
        return `Payment Date must be between ${lowBound.format('MM/DD/YYYY')} and ${upBound.format('MM/DD/YYYY')}.`;
      }
      return true;
    },
  }],
};
